import { render, staticRenderFns } from "./PurchaseOrderTable.vue?vue&type=template&id=bf7cc8f2&scoped=true"
import script from "./PurchaseOrderTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderTable.vue?vue&type=style&index=0&id=bf7cc8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7cc8f2",
  null
  
)

export default component.exports